import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../../../hoc/toJS';
import getData from '../../../functions/getData'
import { CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, FLYER_DATA, UI_GENERAL, PROGRAM_ATTRIBUTES_GLOBAL, PROGRAM_ATTRIBUTES, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_PERFORMANCES, TRANSLATION, UI_PROGRAM, PUSH_DATA_CURRENT_WEEK, PUSH_CREATE_DATA, PUSH_CREATE_CURRENT_WEEK, PUSH_CREATE_STATUS, PROGRAM_CINEMAS } from '../../../constants/state'
import hasUpdateProgram from '../../../hoc/hasUpdateProgram';
import pushConfig from '../../../push-config.json'
import config from '../../../config.json'
import PushCreatePage from '../present/create/PushCreatePage';
import filterMoviesByWeekAndCinema from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByWeekAndCinema';
import filterItemsByOrder from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByOrder';
import { MOVIE } from '../../../constants/itemTypes';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import Translation from '../../Translation/cont/Translation';
import { pushCreateAttachedItemUpdate, pushCreateFormUpdate, pushCreateRequest } from '../../../actions';
import filterItemsByCinemasArray from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByCinemasArray';
import filterMoviesByWeekAndCinemas from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByWeekAndCinemas';
import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../../../functions/getDateFromWeek';
import filterMoviesByTimeRangeAndCinema from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByTimeRangeAndCinema';
import getCinemaIdsByMovie from '../../../functions/cinemaAndTimeRangeFilters/getCinemaIdsByMovie';
import sortCinemas from '../../../functions/sortCinemas';


const mapStateToProps = (state, ownProps) => ({
    attributes: getData(state, PROGRAM_ATTRIBUTES_GLOBAL),
    attributesData: getData(state, PROGRAM_ATTRIBUTES),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    currentWeek: getData(state, [PUSH_CREATE_CURRENT_WEEK]),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    displayMovies: true,
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    movieOrder: getData(state, PROGRAM_CLI_MOVIES_ORDER),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    performancesData: getData(state, PROGRAM_PERFORMANCES),
    pushCreateData: getData(state, [PUSH_CREATE_DATA]),
    status: getData(state, [PUSH_CREATE_STATUS]),
    translation: getData(state, TRANSLATION),
    uiRequestOverlayType: getData(state, [UI_GENERAL, 'requestOverlay', 'overlayType']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onCreatePush: () => {
        dispatch(pushCreateRequest())
    },
    onFormUpdate: (itemData) => {
        dispatch(pushCreateFormUpdate(itemData))
    },
    onAttachedItemUpdate: (attachedItemData) => {
        dispatch(pushCreateAttachedItemUpdate(attachedItemData))
    },
})

const dragListConfig = [
    {
        titleTransId: 'section_filter_current_movies',
        buttonTextTransId: null,
        type: MOVIE,
        dataType: 'currentMovies',
        hasAddNewItem: false,
        hasRemoveItem: false
    },
    {
        titleTransId: 'print_upcoming_movies',
        buttonTextTransId: null,
        type: MOVIE,
        dataType: 'futureMovies',
        hasAddNewItem: false,
        hasRemoveItem: false
    },
    // {
    //     titleTransId: 'print_flyer_image_elements_selection',
    //     buttonTextTransId: 'print_flyer_new_image_element',
    //     type: IMAGE,
    //     itemsType: 'imageElements',
    //     hasAddNewItem: true,
    //     hasRemoveItem: true
    // }
]

const PushCreateContainer = ({
    attributesData,
    basicUrl,
    cliCinemas,
    clientCinemaId,
    currentWeek,
    displayDropzones,
    movieData,
    movieOrder,
    onAttachedItemUpdate,
    onCreatePush,
    onFormUpdate,
    performancesData,
    pushCreateData,
    status
}) => {

    const weekPeriodeStartDate = getFromWeekCinemaStartDate(currentWeek.isoWeek, currentWeek.year)
    const weekPeriodeEndDate = getFromWeekCinemaEndDate(currentWeek.isoWeek, currentWeek.year)
    const relevantMovies =  filterMoviesByTimeRangeAndCinema(movieOrder, movieData, performancesData, weekPeriodeStartDate, weekPeriodeEndDate, pushCreateData.form.cinemasFilter)

    let selectedMovies = []
    let enabledCinemaIds = sortCinemas(clientCinemaId, cliCinemas)
    
    if(pushCreateData?.attachedItem?.itemId){
        const movieId = pushCreateData.attachedItem.itemId
        selectedMovies = [movieId]
        enabledCinemaIds = getCinemaIdsByMovie(movieData, performancesData, movieId, weekPeriodeStartDate, weekPeriodeEndDate)
    }
    
    const movieItemsData = {
        order: relevantMovies.relevant,
        items: filterItemsByOrder(relevantMovies.relevant, movieData),
        selectedItems: selectedMovies,
        current: relevantMovies.current,
        future: relevantMovies.future,
        attributes: attributesData,
        enabledCinemaIds: enabledCinemaIds
    }

    const closePagePath = config.routes.apps.path
    const disableButton = pushCreateData?.form?.valid != true

    return (
        <WrapperPageSimple
            pageTitle={[<Translation key="name_one" id={pushConfig.routes["create"].transIdname} />]}
            closePagePath={closePagePath} >
            <PushCreatePage
                key={pushCreateData.key}
                basicUrl={basicUrl}
                cliCinemas = {cliCinemas}
                clientCinemaId = {clientCinemaId}
                closePagePath={closePagePath}
                disableButton={disableButton}
                displayDropzones={displayDropzones}
                dragListConfig={dragListConfig}
                movieItemsData={movieItemsData}
                movieItemsDataCallback={itemsDataCallback}
                onAttachedItemUpdate={onAttachedItemUpdate}
                onCreatePush={onCreatePush}
                onFormUpdate={onFormUpdate}
                pushCreateData={pushCreateData}
                status={status}
                week={currentWeek}
            />
        </WrapperPageSimple>
    )
}

function itemsDataCallback(dataType, itemsData) {
    let itemsOrder = []
    if ('currentMovies' === dataType) {
        itemsOrder = itemsData.current
    } else if ('futureMovies' === dataType) {
        itemsOrder = itemsData.future
    }
    return {
        items: itemsData.items,
        order: itemsOrder,
        selected: itemsData.selectedItems
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    hasUpdateProgram(),
    toJS()
)(PushCreateContainer)